var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgF1ModeEcoLocked1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 5h2v3l3.39 3L61 14v3h-2v3h15v-3h-2v-3l-3.39-3L72 8V5h2V2H59v3zm10 10.32V17h-5v-1.68l2.5-2.18 2.5 2.18zM64 5h5v1.68l-2.5 2.18L64 6.68V5zm-6.34 46.1a20.18 20.18 0 01-9.89 7.06c-10.92 3.53-22.72-2.73-26.36-14-3.64-11.27 2.26-23.24 13.18-26.77.71-.223 1.43-.407 2.16-.55A20.93 20.93 0 0057.66 51.1z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/F1_Mode_eco_locked_1.a1b56e27.svg";
export { SvgF1ModeEcoLocked1 as ReactComponent };